import { AfterViewInit, Component } from '@angular/core';
import * as L from 'leaflet';
import { LatLngTuple } from 'leaflet';
import { Hero } from '../../common/hero/hero';

@Component({
  selector: 'app-info-page',
  imports: [Hero],
  templateUrl: './info-page.html',
  styleUrl: 'info-page.scss',
})
export class InfoPage implements AfterViewInit  {

  private map!: L.Map
  private coordinatesGranoupiac: LatLngTuple = [43.64575973962371, 3.5221796046960767];
  markers: L.Marker[] = [
    L.marker(this.coordinatesGranoupiac)
  ];

  ngAfterViewInit() {
    this.initMap();
  }


  private initMap() {
    const baseMapURl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    this.map = L.map('map').setView(this.coordinatesGranoupiac, 9);
    L.tileLayer(baseMapURl).addTo(this.map);

    L.marker(this.coordinatesGranoupiac)
      .addTo(this.map)
      .bindPopup("Château de Granoupiac")
      .openPopup();

    this.map.panBy([50, 0], { animate: false });
  }
}
